import React, { FC } from "react";
import styles from "./Contacts.module.scss";

import CardInCard from "components/CardInCard/CardInCard";

export interface ContactsProps {}

const Contacts: FC<ContactsProps> = (props) => {
  const title = <h2 className="my-4">Контакты</h2>;
  const content = (
    <div className="row items-center">
      <div className="col-12 col-md-6  my-3 d-flex justify-content-center align-items-center">
        <div>
          <div className="fw-bold">
            Общество с ограниченной ответственностью <br />
            «ПрофИТ Софт»
          </div>
          <div>ИНН 7205015949</div>
          <div>ОГРН 1057200076009</div>
          <div className="my-3"></div>
          <div className="fw-bold">Адрес</div>
          <a href="https://yandex.ru/maps/-/CCU1U-HroA" target="__blank">
            <div>
              627753, Тюменская область, <br />
              г. Ишим, ул. 30 лет ВЛКСМ, д. 28/2
            </div>
          </a>
          <div className="my-3"></div>
          <div className="fw-bold">Телефон</div>
          <div>
            <a href="tel:+73455150445">+7 (34551) 5-04-45</a>
          </div>
          <div>
            <a href="tel:+73455175299">+7 (34551) 7‒52‒99</a>
          </div>
          <div className="my-3"></div>
          <div className="fw-bold">Электронная почта</div>
          <div>
            <a href="mailto:ctckav@mail.ru">ctckav@mail.ru</a>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 d-flex">
        {/* https://yandex.ru/map-constructor */}
        <iframe
          className={styles.ContactsMap}
          title="yamap"
          src="https://yandex.ru/map-widget/v1/?um=constructor%3Ab16db0c74bc1ae8850e01a7ec9055cbea85d2f8f21b563f025bd89d3199cf26e&amp;source=constructor"
          width="100%"
          height="368"
          frameBorder="0"
        ></iframe>
      </div>
    </div>
  );
  const cardInCardProps = { title, content };
  return (
    <div className={styles.Contacts}>
      <CardInCard {...cardInCardProps} />
    </div>
  );
};

export default Contacts;
